import * as React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'

type Props = {
  /** The linked-record deep link; the footer is omitted when absent. */
  deepLink?: string
}

/**
 * Sticky footer with the "View Detail Page" action, which opens the linked
 * lead/opportunity in a new, same-origin tab (E5). Omitted when there is no link.
 */
export function PopoverFooter({ deepLink }: Props) {
  const theme = useTheme()
  if (!deepLink) return null

  return (
    <Box
      sx={{
        padding: '14px 20px',
        borderTop: `1px solid ${theme.palette.divider}`,
        position: 'sticky',
        bottom: 0,
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Button
        variant="contained"
        fullWidth
        disableElevation
        onClick={() => window.open(deepLink, '_blank', 'noopener,noreferrer')}
        data-test-id="event-detail-view-page"
        sx={{ textTransform: 'none' }}
      >
        View Detail Page
      </Button>
    </Box>
  )
}
